import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { IModalService } from 'angular-ui-bootstrap';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { BusinessUnionTypeEnum } from '../../../../../app.admin/modules/model/business-union-type.enum';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { SalesAssistant } from '../../../core';
import { IStoreForShopingListItem } from '../../../store-managers/models';
import { JispPayService } from '../../jispPay.service';
import { ISalesAssistantListItem } from '../../models';

class JispPayAccountComponent implements ng.IController {

    public static $inject = [
        '$timeout',
        'jispPayService',
        'notificationService',
        '$translate',
        '$q',
        '$uibModal',
        '$localStorage'
    ];

    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public resolve: {
        staff: ISalesAssistantListItem,
        places: IStoreForShopingListItem[]
    };
    public waiting: boolean;
    public form: ng.IFormController;

    public data = {
        title: this.$translate.instant('staff_account'),
        textBtn: '',
        avatarUrl: '',
        showPassword: false,
        isPasswordExist: false,
        isEditStaff: false,
        password: 'Password',
        places: [] as IStoreForShopingListItem[],
        staffLogin: '',
        model: null as SalesAssistant,
        staffID: null as number
    };
    public businessUnionTypeEnum = BusinessUnionTypeEnum;
    public businessUnionType: BusinessUnionTypeEnum;

    constructor(
        private $timeout: ng.ITimeoutService,
        private jispPayService: JispPayService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private $q: angular.IQService,
        private $modal: IModalService,
        private $localStorage: ngStorage.StorageService,
    ) {
    }

    public async $onInit() {
        await this.init();
    }

    public changePlaces() {
        this.data.model.PlacesID = _.pluck(_.where(this.data.places, { selected: true }), 'ID');
        this.form.$setDirty();
    }

    public async imageClick() {
        try {
            const avatarID = await this.$modal.open({
                component: 'jispPayAvatar',
                resolve: {
                    title: () => this.$translate.instant('staff_photo_title'),
                    getUrl: () => this.jispPayService.getAvatarUrl(this.data.model.AvatarID, null, null),
                    avatarId: () => this.data.model.AvatarID,
                    saveUrl: () => this.jispPayService.getAvatarUploadUrl()
                },
                backdrop: 'static'
            }).result;
            if (avatarID) {
                this.form.$setDirty();
                this.data.model.AvatarID = avatarID;
                this.data.avatarUrl = await this.jispPayService.getAvatarUrl(avatarID, 124, 124);
            }
        } catch (error) {
            return;
        }
    }

    public async save() {
        if (this.form.$invalid) {
            return;
        }

        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await (this.data.isEditStaff ? this.jispPayService.updateStaff(this.data.staffID, this.data.model) :
                this.jispPayService.createStaff(this.data.model));
            this.notificationService.showSuccessMessage();
            this.modalInstance.close({ $value: true });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }

        this.waiting = false;
    }

    public close() {
        this.modalInstance.close({ $value: false });
    }

    private async init() {
        await this.$timeout(0);

        const txtSave = this.$translate.instant('button_save_staff_member');
        const txtCreate = this.$translate.instant('button_create_staff_member');
        const i = this.data;
        i.textBtn = this.resolve.staff ? txtSave : txtCreate;

        i.isPasswordExist = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
        i.isEditStaff = this.resolve.staff && _.isNumber(this.resolve.staff.ID);

        i.places = this.resolve.places ? _.filter(_.map(this.resolve.places, (place) => {
            place.selected = this.resolve.staff ? _.contains(this.resolve.staff.PlacesID, place.ID) : false;
            return place;
        }), (place) => {
            return place.selected || (place.IsActive && !place.IsBanned);
        }) : [];

        i.avatarUrl = (this.resolve.staff && this.resolve.staff.AvatarID)
            ? this.jispPayService.getAvatarUrl(this.resolve.staff.AvatarID, 124, 124)
            : '';

        i.staffLogin = this.resolve.staff ? this.resolve.staff.Login : '';
        i.model = {
            FirstName: this.resolve.staff ? this.resolve.staff.FirstName : '',
            LastName: this.resolve.staff ? this.resolve.staff.LastName : '',
            Login: this.resolve.staff ? this.resolve.staff.Login : '',
            Password: '',
            Interests: this.resolve.staff ? this.resolve.staff.Interests : '',
            LovedProducts: this.resolve.staff ? this.resolve.staff.LovedProducts : '',
            WorkingInfo: this.resolve.staff ? this.resolve.staff.WorkingInfo : '',
            PlacesID: this.resolve.staff ? this.resolve.staff.PlacesID : [],
            AvatarID: (this.resolve.staff && this.resolve.staff.AvatarID)
                ? this.resolve.staff.AvatarID
                : null,
            WholesaleDeliveryDriver: this.resolve.staff ? this.resolve.staff.WholesaleDeliveryDriver : false
        };
        i.staffID = this.resolve.staff ? this.resolve.staff.ID : null;

        const loginModel = this.form.login as ng.INgModelController;
        loginModel.$asyncValidators.isInUse = this.validateLogin.bind(this);

        const passwordModel = this.form.password as ng.INgModelController;
        passwordModel.$validators.password = this.validatePassword.bind(this);
        this.businessUnionType = this.$localStorage.BusinessUnionType;
    }

    private validatePassword(modelValue: string): boolean {
        const password = this.jispPayService.trim(modelValue);
        const isEmpty = _.size(password) < 1;

        if (this.data.isEditStaff && isEmpty) {
            return true;
        }

        return !isEmpty;
    }

    private validateLogin(modelValue: string, viewValue: string): angular.IPromise<any> {
        if (_.isEmpty(modelValue)) {
            return this.$q.resolve();
        }

        // do not validate login if user edits member
        if (this.data.isEditStaff && viewValue === this.data.staffLogin) {
            return this.$q.resolve();
        }

        const result = this.$q.defer();
        this.jispPayService.jisppayStaffLoginExist(viewValue)
            .then((response) => response ? result.reject() : result.resolve())
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
                result.resolve();
            });

        return result.promise;
    }
}

angular.module('naut').component('jispPayAccount', {
    template: require('./jispPayAccount.html'),
    controller: JispPayAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/jispPayAccount/jispPayAccount.component.ts